import { SpaceMouseConfig } from "./spacemouse.types";

export const SPACEMOUSE_VENDOR_ID = 0x256f;

export const SPACEMOUSE_PRODUCT_IDS = {
  SPACEMOUSE_COMPACT: 0xc635,
  SPACEMOUSE_PRO: 0xc62b,
  SPACEMOUSE_PRO_WIRELESS: 0xc632,
  SPACEMOUSE_WIRELESS: 0xc62e,
  SPACEMOUSE_ENTERPRISE: 0xc633,
  SPACEMOUSE_MODULE: 0xc636,
  SPACEPILOT_PRO: 0xc625,
  CADMOUSE_COMPACT_WIRELESS: 0xc651,
} as const;

export const REPORT_IDS = {
  TRANSLATION: 1,
  ROTATION: 2,
  BUTTONS: 3,
} as const;

export const DEFAULT_CONFIG: SpaceMouseConfig = {
  panSensitivity: 1.0,
  zoomSensitivity: 0.125,
  deadZone: 15,
  zoomDeadZone: 30,
  invertPanX: false,
  invertPanY: false,
  invertZoom: true,
};

export const MAX_AXIS_VALUE = 350;

export const ZOOM_THRESHOLD = 100;
